export default {
  data() {
    return {
      hotelOrderTypeList: [
        {
          value: '03001',
          label: '酒店正常单',
          list: [
            {
              value: 'H1',
              label: '已预订'
            },
            {
              value: 'H3',
              label: '已确认'
            },
            {
              value: 'H7',
              label: '客户消'
            },
            {
              value: 'H8',
              label: '系统消'
            },
            {
              value: 'H9',
              label: '已完成'
            },
            {
              value: 'H10',
              label: 'NOSHOW'
            },
            {
              value: 'H11',
              label: '已入住'
            },
            {
              value: 'H12',
              label: '已离店'
            }
          ]
        },
        {
          value: '03002',
          label: '酒店退单',
          list: [
            {
              value: '0',
              label: '待审核'
            },
            {
              value: '1',
              label: '已审核待退款'
            },
            {
              value: '4',
              label: '已退款完成'
            },
            {
              value: '5',
              label: '取消'
            }
          ]
        }
      ],
      hotelOrderStatusList: [],
      planeTicketOrderTypeList: [
        {
          value: '01001',
          label: '国内机票正常单',
          list: [
            {
              value: '0',
              label: '申请中'
            },
            {
              value: '1',
              label: '已订座'
            },
            {
              value: '2',
              label: '已调度'
            },
            {
              value: '3',
              label: '已出票状态'
            },
            {
              value: '4',
              label: '配送中'
            },
            {
              value: '5',
              label: '出票中/部分出票'
            },
            {
              value: '6',
              label: '假RR'
            },
            {
              value: '7',
              label: '客户取消'
            },
            {
              value: '8',
              label: '管理员取消'
            },
            {
              value: '9',
              label: '完成状态'
            }
          ]
        },
        {
          value: '01002',
          label: '国内机票退票单',
          list: [
            {
              value: 'A',
              label: '待审核'
            },
            {
              value: '0',
              label: '待确认'
            },
            {
              value: '1',
              label: '已申请'
            },
            {
              value: '3',
              label: '已调度'
            },
            {
              value: '6',
              label: '已打单'
            },
            {
              value: '4',
              label: '配送中'
            },
            {
              value: '5',
              label: '已完成'
            },
            {
              value: '7',
              label: '已取消'
            }
          ]
        },
        {
          value: '01003',
          label: '国内机票改签单',
          list: [
            {
              value: 'A',
              label: '待审核'
            },
            {
              value: '0',
              label: '待确认'
            },
            {
              value: '1',
              label: '已申请'
            },
            {
              value: '2',
              label: '已调度'
            },
            {
              value: '3',
              label: '改签中'
            },
            {
              value: '4',
              label: '已改签'
            },
            {
              value: '5',
              label: '已打单'
            },
            {
              value: '6',
              label: '配送中'
            },
            {
              value: '7',
              label: '客户消'
            },
            {
              value: '8',
              label: '已取消'
            },
            {
              value: '9',
              label: '已完成'
            }
          ]
        },
        {
          value: '02001',
          label: '国际机票正常单',
          list: [
            {
              value: '0',
              label: '申请中'
            },
            {
              value: '1',
              label: '已订座'
            },
            {
              value: '2',
              label: '已调度'
            },
            {
              value: '3',
              label: '已出票状态'
            },
            {
              value: '4',
              label: '配送中'
            },
            {
              value: '5',
              label: '出票中/部分出票'
            },
            {
              value: '6',
              label: '假RR'
            },
            {
              value: '7',
              label: '客户取消'
            },
            {
              value: '8',
              label: '管理员取消'
            },
            {
              value: '9',
              label: '完成状态'
            }
          ]
        },
        {
          value: '02002',
          label: '国际机票退票单',
          list: [
            {
              value: 'A',
              label: '待审核'
            },
            {
              value: '0',
              label: '待确认'
            },
            {
              value: '1',
              label: '已申请'
            },
            {
              value: '3',
              label: '已调度'
            },
            {
              value: '6',
              label: '已打单'
            },
            {
              value: '4',
              label: '配送中'
            },
            {
              value: '5',
              label: '已完成'
            },
            {
              value: '7',
              label: '已取消'
            }
          ]
        },
        {
          value: '02003',
          label: '国际机票改签单',
          list: [
            {
              value: 'A',
              label: '待审核'
            },
            {
              value: '0',
              label: '待确认'
            },
            {
              value: '1',
              label: '已申请'
            },
            {
              value: '2',
              label: '已调度'
            },
            {
              value: '3',
              label: '改签中'
            },
            {
              value: '4',
              label: '已改签'
            },
            {
              value: '5',
              label: '已打单'
            },
            {
              value: '6',
              label: '配送中'
            },
            {
              value: '7',
              label: '客户消'
            },
            {
              value: '8',
              label: '已取消'
            },
            {
              value: '9',
              label: '已完成'
            }
          ]
        }
      ],
      planeTicketOrderStatusList: [],
      trainTicketOrderTypeList: [
        {
          value: '06001',
          label: '火车票正常单',
          list: [
            {
              value: '1',
              label: '申请中'
            },
            {
              value: '1A',
              label: '抢票中'
            },
            {
              value: '2',
              label: '已订座'
            },
            {
              value: '2A',
              label: '订座中'
            },
            {
              value: '3',
              label: '预订失败'
            },
            {
              value: '4',
              label: '已出票'
            },
            {
              value: '4A',
              label: '出票中'
            },
            {
              value: '5',
              label: '出票失败'
            },
            {
              value: '6',
              label: '取消失败'
            },
            {
              value: '7',
              label: '已取消'
            },
            {
              value: '7A',
              label: '取消中'
            },
            {
              value: '8',
              label: '超时取消'
            }
          ]
        },
        {
          value: '06002',
          label: '改签单状态',
          list: [
            {
              value: '1',
              label: '已申请'
            },
            {
              value: '2',
              label: '预订失败'
            },
            {
              value: '3',
              label: '已确认待改签'
            },
            {
              value: '3A',
              label: '确认中'
            },
            {
              value: '4',
              label: '已改签'
            },
            {
              value: '4A',
              label: '改签中'
            },
            {
              value: '5',
              label: '改签失败'
            },
            {
              value: '6',
              label: '取消失败'
            },
            {
              value: '7',
              label: '已取消'
            },
            {
              value: '7A',
              label: '取消中'
            },
            {
              value: '8',
              label: '超时取消'
            }
          ]
        },
        {
          value: '06003',
          label: '退票单状态',
          list: [
            {
              value: '1',
              label: '已申请'
            },
            {
              value: '1A',
              label: '退票中'
            },
            {
              value: '2',
              label: '已退票待退款'
            },
            {
              value: '5',
              label: '已退票已退款'
            },
            {
              value: '6',
              label: '已作废'
            },
            {
              value: '7',
              label: '退票失败'
            }
          ]
        }
      ],
      trainTicketOrderStatusList: [],
      trainTicketApplyTypeList: [
        {
          value: '退票',
          label: '退票'
        },
        {
          value: '改签',
          label: '改签'
        },
        {
          value: '超标',
          label: '超标'
        }
      ]
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'WelfareMallEnterprise', title: '企业管理' },
      { name: 'WelfareMallStaffList', title: '员工管理' },
      { name: 'WelfareMallAuthentication', title: '认证管理' },
      { name: 'WelfareMallSettings', title: '商城设置' },
      { name: 'WelfareMallStaffRights', title: '员工权益' },
      { name: 'WelfareMallHotelOrder', title: '酒店订单' },
      { name: 'WelfareMallPlaneTicketOrder', title: '机票订单' },
      { name: 'WelfareMallTrainTicketOrder', title: '火车票订单' }
    ])
  },
  methods: {
    // 工具方法：将数组按指定数量分组显示
    chunkArray(arr, size = 4) {
      const result = []
      for (let i = 0; i < arr.length; i += size) {
        result.push(arr.slice(i, i + size))
      }
      return result
    },
    onSelectOrderType(e, type) {
      const orderTypeInfo = {
        'hotel': {
          orderTypeListKey: 'hotelOrderTypeList',
          orderStatusListKey: 'hotelOrderStatusList',
          orderStatusKey: 'ddzt'
        },
        'planeTicket': {
          orderTypeListKey: 'planeTicketOrderTypeList',
          orderStatusListKey: 'planeTicketOrderStatusList',
          orderStatusKey: 'ddzt'
        },
        'trainTicket': {
          orderTypeListKey: 'trainTicketOrderTypeList',
          orderStatusListKey: 'trainTicketOrderStatusList',
          orderStatusKey: 'ddzt'
        }
      }
      const { orderTypeListKey, orderStatusListKey, orderStatusKey } = orderTypeInfo[type]
      this[orderStatusListKey] = e ? this[orderTypeListKey].find(item => item.value === e).list : []
      this.$set(this.queryParams, orderStatusKey, undefined)
    }
  }
}
